import { ActionReducer, createReducer, on } from '@ngrx/store';
import { BoxxGenericState, getGenericInitialState } from '@boxx/core';
import { OnboardingModuleComponentBaseProps } from '../../models/Onboarding.model';
import * as fromOnboardingActions from '../onboarding.actions';
import { IWizardCreateUserPayloadProps } from '../../repositories/IOnboarding.api';
import {
  IOnboardingStateError,
  IOnboardingStateSuccess,
} from '../../core/IStateErrorSuccess';

export type IOnboardingRegistrationState = BoxxGenericState<
  OnboardingModuleComponentBaseProps<IWizardCreateUserPayloadProps>,
  IOnboardingStateSuccess,
  IOnboardingStateError
>;

export const registrationInitialState: IOnboardingRegistrationState = {
  ...getGenericInitialState(),
  data: {
    completed: false,
    fields: null,
  },
};

export const registrationDataReducer: ActionReducer<IOnboardingRegistrationState> =
  createReducer(
    registrationInitialState,
    on(
      fromOnboardingActions.createUserBeginAction,
      (state): IOnboardingRegistrationState => ({
        ...state,
        isLoading: true,
        success: null,
        error: null,
      })
    ),
    on(
      fromOnboardingActions.createUserSuccessAction,
      (state, { payload }): IOnboardingRegistrationState => ({
        ...state,
        data: {
          completed: true,
          fields: { ...state.data.fields, ...payload },
        },
        isLoading: false,
        success: {
          after: 'SAVE',
        },
      })
    ),
    on(
      fromOnboardingActions.createUserFailAction,
      (state, { type, errors }): IOnboardingRegistrationState => ({
        ...state,
        isLoading: false,
        error: {
          after: 'SAVE',
          error: errors,
        },
      })
    ),

    on(
      fromOnboardingActions.clearOnboardingRegistraionSuccessErrorDataAction,
      (state) => ({
        ...state,
        error: null,
        success: null,
      })
    )
  );
